module.exports = __webpack_public_path__ + "static/media/sence2.57cde21e.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/sence2.png
// module id = 543
// module chunks = 0